import React from 'react';
import classNames from 'classnames';
import { useFormState } from 'react-final-form';

import { FieldPhoneNumberInput } from '../../components';
import { getCountryCode } from '../../util/countryCodes';

import css from './PhoneNumberWithCountryCode.module.css';

/**
 * Phone number input with country code prefix
 * Shows a small fixed field with country code when country is selected
 *
 * @component
 * @param {Object} props
 * @param {string} props.className - Additional CSS class
 * @param {string} props.id - Input ID
 * @param {string} props.name - Field name
 * @param {string} props.label - Field label
 * @param {string} props.placeholder - Placeholder text
 * @param {Function} props.validate - Validation function
 * @returns {JSX.Element}
 */
const PhoneNumberWithCountryCode = props => {
  const { className, label, ...restProps } = props;

  // Get form values to access the country field
  const formState = useFormState();
  // Check various possible field names for country
  // pub_country_bio is the custom user field for country in signup/profile
  // country is used in other forms like payment forms
  const country = formState?.values?.pub_country_bio ||
                  formState?.values?.country_bio ||
                  formState?.values?.country || null;

  // Get the country code to display
  const displayCountryCode = country ? getCountryCode(country) : null;

  return (
    <div className={classNames(css.wrapper, className)}>
      {label && <label className={css.label}>{label}</label>}
      <div className={css.inputRow}>
        {displayCountryCode && (
          <div className={css.countryCodeBox}>
            {displayCountryCode}
          </div>
        )}
        <div className={css.phoneInputWrapper}>
          <FieldPhoneNumberInput
            {...restProps}
            label={null}
            className={css.phoneInput}
          />
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberWithCountryCode;
